import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Sparkles, HandHeart } from "lucide-react";
import { api } from "@/lib/apiClient";

export default function PraiseReports() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { api.get("/praise-reports").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoaded(true)); }, []);

  return (
    <div className="min-h-screen bg-bone pt-20 md:pt-14 pb-24">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-black">Praise Reports</span>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">Answered Prayers</h1>
          <p className="font-sans text-charcoal/60 mt-4 max-w-xl">
            Every one of these began as a burden and became a testimony. Be encouraged — God is moving among the brothers.
          </p>
        </Reveal>

        {loaded && items.length === 0 && (
          <Reveal delay={0.1}>
            <div className="mt-16 border border-charcoal/10 p-12 text-center">
              <Sparkles size={36} className="mx-auto text-gold" strokeWidth={1.4} />
              <p className="font-serif text-2xl tracking-tight mt-4">No praise reports yet.</p>
              <p className="font-sans text-charcoal/55 mt-2">When a prayer on the wall is marked answered with a testimony, it appears here.</p>
            </div>
          </Reveal>
        )}

        <div className="mt-14 space-y-6">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 5) * 0.05}>
              <div className="border border-gold/25 bg-gold/[0.04] p-8 md:p-10" data-testid={`praise-${p.id}`}>
                <div className="flex items-center gap-2">
                  <Sparkles size={14} className="text-gold" strokeWidth={1.6} />
                  <span className="font-mono text-[10px] uppercase tracking-widest text-gold">Answered</span>
                </div>
                <p className="font-serif text-2xl md:text-3xl leading-snug tracking-tight mt-5 text-charcoal/90">"{p.testimony}"</p>
                <div className="mt-6 pl-5 border-l-2 border-charcoal/15">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-charcoal/40">The original request</span>
                  <p className="font-sans text-charcoal/60 italic mt-1">{p.body}</p>
                </div>
                <div className="mt-6 pt-5 border-t border-charcoal/10 flex items-center justify-between">
                  <span className="font-mono text-xs uppercase tracking-widest text-charcoal/50">{p.author}</span>
                  <span className="font-mono text-[10px] text-charcoal/40 flex items-center gap-2"><HandHeart size={13} /> {p.pray_count} prayed</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
